import { Box, CircularProgress, Toolbar, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import NavBar from './NavBar';
import { RenderBlockElement } from './PageComponentElementBlocks';
import { terbebasClient } from '../terbebasApi';
import { restoreStoreTitle } from '../storeBranding';

// Merchant-built custom page: renders one UIBlockElement[] fetched by
// handle (same section vocabulary as collection layouts / the homepage).
export default function PageCustomCommerce() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  const { pageHandle } = useParams<{ pageHandle: string }>();

  const [page, setPage] = useState<any>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    setPage(null);
    setError('');
    terbebasClient.get('/storefront/pages/' + pageHandle)
      .then((res) => {
        setPage(res.data);
        if (res.data?.title) document.title = res.data.title;
      })
      .catch(() => setError('Halaman tidak ditemukan.'));
    // The page's own title must not outlive it — without this the shopper
    // carries "Kebijakan Privasi" into every subsequent route.
    return restoreStoreTitle;
  }, [pageHandle]);

  return (
    <Box>
      <NavBar transparentAtTop={false} transparent={false} coloredAtTop={false} largerTitleAtTop={false} />
      <Toolbar />
      {
        error ?
        <Typography style={{textAlign: 'center', padding: '80px 0', fontWeight: 300}}>{error}</Typography> :
        !page ?
        <Box style={{textAlign: 'center', padding: '80px 0'}}><CircularProgress /></Box> :
        <Box>
          {
            (Array.isArray(page.elements) ? page.elements : []).map((block: any, i: number) => (
              <RenderBlockElement
                key={i}
                code={isDesktop ? block.elementDesktopCode : block.elementMobileCode}
                contentJson={isDesktop ? block.elementDesktopContentJson : block.elementMobileContentJson}
              />
            ))
          }
        </Box>
      }
    </Box>
  );
}
